__turbopack_context__.v({
  "dealsBannerContainer": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__dealsBannerContainer",
  "dealsBannerContainerWrapper": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__dealsBannerContainerWrapper",
  "endDate": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__endDate",
  "inCartDiscount": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__inCartDiscount",
  "priceAndReviews": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__priceAndReviews",
  "saleIcon": "ProductPriceAndReviewsContainer-module-scss-module__wm9c3W__saleIcon",
});
